import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../base';

const EmailConfirmationSuccessModal = ({ show, onClose, setShowCanvasPopupModal, setShowAuthModal, setLogin }) => {
  const { t } = useTranslation();
  const currentUser = useAuth();

  const handleContinueAsLoggedInUser = () => {
    onClose(); // Close the modal
    setShowCanvasPopupModal(true); // Show project creation modal
    window.history.pushState({}, document.title, "/");
  };

  const handleLoginPrompt = () => {
    onClose(); // Close the success modal
    setLogin(true); // Set to login mode (not signup)
    setShowAuthModal(true); // Show the auth modal for login
    window.history.pushState({}, document.title, "/");
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t('emailConfirmationSuccessTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {currentUser ? (
          // User is already logged in - just confirmed their email
          <p>{t('emailConfirmationSuccessMessage')}</p>
        ) : (
          // User is not logged in - need to prompt them to log in
          <div>
            <p>{t('emailConfirmationSuccessLoggedOutMessage')}</p>
            <p className="text-muted">{t('emailConfirmationSuccessLoginPrompt')}</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        {currentUser ? (
          <Button variant="primary" onClick={handleContinueAsLoggedInUser}>
            {t('emailConfirmationSuccessButton')}
          </Button>
        ) : (
          <Button variant="primary" onClick={handleLoginPrompt}>
            {t('emailConfirmationSuccessLoginButton')}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default EmailConfirmationSuccessModal;
